module.exports = __webpack_public_path__ + "static/media/study220706.d1964874.png";